import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./components/page/Home";
import Tracking  from "./components/page/Tracking";
import About from "./components/page/About";
import PrivacyPolicy from "./components/page/PrivacyPolicy";
import TermsConditions from "./components/page/TermsConditions";
import CookiePolicy from "./components/page/CookiePolicy";
import ServicesPage from "./components/page/ServicesPage";
import Contact from "./components/page/Contact";
import TrackingBox from "./components/page/TrackingBox";
import ScrollToTop from "./components/page/ScrollToTop";

function App() {
  return (
   <BrowserRouter>
      <ScrollToTop />  
      <Navbar />
      

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tracking" element={<Tracking />} /> 
        <Route path="/about" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/tracking-box" element={<TrackingBox />} />
      </Routes>
       <Footer/>
    </BrowserRouter>
  );
}


export default App;
